module.exports = __webpack_public_path__ + "static/img/20.e46a6e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/20.png
// module id = apa3
// module chunks = 0